import { createContext, useContext, useState } from 'react';
import { AppointmentHistory } from '../types/history';

// datatype of the context declared here
interface IRescheduleProvider {
  showRescheduleModal: boolean;
  showDetailsModal: boolean;
  isAssociate: boolean;
  appointment: AppointmentHistory | null;
  setShowRescheduleModal: React.Dispatch<React.SetStateAction<boolean>>;
  setShowDetailsModal: React.Dispatch<React.SetStateAction<boolean>>;
  setIsAssociate: React.Dispatch<React.SetStateAction<boolean>>;
  setAppointment: React.Dispatch<
    React.SetStateAction<AppointmentHistory | null>
  >;
}

// creating the context here
const RescheduleContext = createContext<IRescheduleProvider | null>(null);

const RescheduleProvider = ({ children }: { children: React.ReactNode }) => {
  // integration of react hooks here
  const [appointment, setAppointment] = useState<AppointmentHistory | null>(
    null
  );
  const [showDetailsModal, setShowDetailsModal] = useState<boolean>(false);
  const [isAssociate, setIsAssociate] = useState<boolean>(false);
  const [showRescheduleModal, setShowRescheduleModal] =
    useState<boolean>(false);

  // rendering the context provider here
  return (
    <RescheduleContext.Provider
      value={{
        showRescheduleModal,
        showDetailsModal,
        isAssociate,
        appointment,
        setShowRescheduleModal,
        setShowDetailsModal,
        setIsAssociate,
        setAppointment,
      }}
    >
      {children}
    </RescheduleContext.Provider>
  );
};

export default RescheduleProvider;

// creating custom hook to access the reschedule context here
export const useRescheduleContext = () => {
  const context = useContext(RescheduleContext);

  if (!context) {
    throw new Error('useRescheduleContext must be within RescheduleProvider!');
  }

  return context;
};
